import(/* webpackMode: "eager" */ "/codebuild/output/src4179363947/src/patient-app/app/global-error.tsx");
